import React from "react";
import ReactApexChart from "react-apexcharts";
import { IReportMetricsTotal } from "../../../../../@types/reports-metrics.type";
import styles from "./styles.module.scss";

export const PieChart: React.FC<IReportMetricsTotal> = ({
  unavailabilities,
}) => {
  const series =
    unavailabilities.length > 0
      ? unavailabilities.map((element) => element.percentage)
      : [0];

  const labels = unavailabilities.length
    ? unavailabilities.map((element) => element.name)
    : ["Sem indisponibilidade no período"];

  const options = {
    colors: ["#e74242", "#ef6a6a", "#ffaaaa", "#ffd8d8"],
    chart: {
      type: "donut",
      fontFamily: "archivo, sans-serif",
      width: "100%",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: "100%",
            height: 300,
          },
          legend: {
            position: "left",
          },
        },
      },
    ],
    legend: {
      show: true,
      position: "left",
      horizontalAlign: "left",
      fontSize: "13px",
      fontWeight: 400,
      labels: {
        colors: ["#616161"],
      },
      formatter: function (val, { seriesIndex }) {
        return unavailabilities.length > 0
          ? `${val} (${unavailabilities[seriesIndex].totalHours}h)`
          : `${val}`;
      },
    },
    dataLabels: {
      formatter: function (val) {
        return Math.round(val).toString().replace(".", ",") + "%";
      },
      dropShadow: {
        enabled: true,
        top: 0,
        left: 0,
        blur: 0,
        opacity: 0.5,
      },
      style: {
        colors: ["#212121"],
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex }) {
        const value = series[seriesIndex];
        const label = labels[seriesIndex];

        return `
          <div class='labelCustom' style="flex-direction: row;">
            <strong>${label}:</strong>
            <span>${value.toString().replace(".", ",")}%</span>
          </div>
        `;
      },
    },
    title: {
      text: "Indisponíbilidade",
      style: {
        color: "#212121",
        fontWeight: 600,
      },
    },
    labels,
  };

  return (
    <div className={styles.mainCard}>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          height="250"
          width="100%"
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};
